import { render, staticRenderFns } from "./NuevaLiquidacion.vue?vue&type=template&id=c6cc01fa&scoped=true"
import script from "./NuevaLiquidacion.vue?vue&type=script&lang=js"
export * from "./NuevaLiquidacion.vue?vue&type=script&lang=js"
import style0 from "./NuevaLiquidacion.vue?vue&type=style&index=0&id=c6cc01fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cc01fa",
  null
  
)

export default component.exports